import React, { Suspense, lazy, useState, useEffect } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '../../utils/webpack/chunkRetry';
const MediaSelector = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "mediaPopup", webpackPrefetch: true */ './MediaSelector')));
export const LoadableMediaSelector = (props)=>{
    const [mounted, setMounted] = useState(false);
    useEffect(()=>{
        setMounted(true);
    }, []);
    const waitForMount = typeof window === 'undefined' && !mounted;
    if (waitForMount) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableMediaSelector"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'spinner',
            coverMode: true
        })
    }, /*#__PURE__*/ React.createElement(MediaSelector, props)));
};
LoadableMediaSelector.displayName = 'LoadableMediaSelector';
export default LoadableMediaSelector;

//# sourceMappingURL=LoadableMediaSelector.js.map